var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-wrap"},[_c('textarea',{attrs:{"name":"stringInput","id":"string-input"}}),_c('br'),_c('button',{on:{"click":function($event){return _vm.countIt()}}},[_vm._v("Count it!")])])}
var staticRenderFns = []

export { render, staticRenderFns }